import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { toast } from "react-toastify";
import { Modal as AntModal } from "antd";
import PDFview from "../../../components/PdfView";
import Modal from "react-modal";

const BillOfExchangeList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);

  const [docurl, setDocUrl] = useState(false);
  const [billOfExchangeId, setBillOfExchangeId] = useState("");

  const { sendRequest: getBillOfExchange } = useHttp();

  useEffect(() => {
    getBillOfExchange(
      {
        url: "/api/billOfExchange/",
      },
      (res) => {
        if (res) {
          setData(res);
          //console.log(res);
        }
      }
    );
  }, [getBillOfExchange]);

  const viewPdf = (itemId) => {
    setDocUrl("https://www.orimi.com/pdf-test.pdf");
    setBillOfExchangeId(itemId);
  };

  const { sendRequest: formDataDelete } = useHttp();

  const deleteHandler = (e, billOfExchangeId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this Bill Of Exchange detail?",
      onOk() {
        const data = {
          billOfExchangeId: billOfExchangeId,
        };
        //console.log(data);

        formDataDelete(
          {
            url: "/api/billOfExchange/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success(data);
          }
        );
      },
      onCancel() {},
    });
  };
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "800px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    setSelectedData(data);
    //console.log(data);

    setIsModalOpen(true);
  };
  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">Bill Of Exchange </label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Bill Of Exchange
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Bill of Exchange id </th>
                          <th> B/L Date</th>
                          <th>Customer Name</th>
                          <th>Customer id </th>
                          <th>Amount if Figures</th>

                          <th>Currency </th>
                          <th>Issued by</th>
                          {/* <th>Edit</th> */}
                          <th>Delete</th>
                          <th>Pdf</th>
                          <th>View</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.date}</td>
                                <td>{itm.billOfExchnageNo}</td>
                                <td>{itm.bLDate}</td>
                                <td>{itm.customerName}</td>
                                <td>{itm.customerCode}</td>
                                <td>{itm.amtInFigures}</td>
                                <td>{itm.currencyCode}</td>
                                <td>{itm.issuedBy}</td>
                                {/* <td>
                                  {itm.isGoodReciept === "Yes" ? (
                                    <button className="btn" disabled>
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  ) : (
                                    <button
                                      onClick={() => {
                                        props.update(itm);
                                        props.addForm(true);
                                      }}
                                      className="btn"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  )}
                                </td> */}
                                <td>
                                  {itm.isGoodReciept === "Yes" ? (
                                    <button className="btn" disabled>
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  ) : (
                                    <button
                                      className="btn"
                                      onClick={(e) =>
                                        deleteHandler(e, itm.billOfExchangeId)
                                      }
                                    >
                                      {" "}
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  )}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() =>
                                      viewPdf(itm.billOfExchangeId)
                                    }
                                  >
                                    <i className="fa fa-solid fa-file"></i>
                                  </button>
                                </td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(itm)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {docurl && (
        <Modal isOpen={true} style={customModalStyles}>
          {billOfExchangeId && (
            <div className="row">
              <div className="col-md-11">
                <button
                  className="btn btn-sm btn-success"
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_BASE_URL}/api/billOfExchange_pdf/?billOfExchangeId=${billOfExchangeId}`,
                      "_blank"
                    )
                  }
                >
                  Download
                </button>
              </div>
              <div className="col-md-1">
                <div className="card-tools">
                  <button
                    type="button"
                    className="btn btn-tool"
                    data-card-widget="remove"
                    onClick={() => setDocUrl(false)}
                  >
                    <i className="fas fa-times" />
                  </button>
                </div>
              </div>
            </div>
          )}
          <PDFview
            docurl={`${process.env.REACT_APP_BASE_URL}/api/billOfExchange_pdf/?billOfExchangeId=${billOfExchangeId}`}
          />
        </Modal>
      )}

      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div className="mx-3">
            <h4 className="card-title">Bill Of Exchange Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6">
                Bill Of Exchange No: {selectedData.billOfExchnageNo}
              </p>
              <p className="col-md-6">
                Commercial Invoice No: {selectedData.commercialInvoiceNo}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Date: {selectedData.date}</p>
              <p className="col-md-6">
                Date Of Issue : {selectedData.dateOfIssue}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Customer Name: {selectedData.customerName}
              </p>

              <p className="col-md-6">
                Place of Issue: {selectedData.placeOfIssue}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">At: {selectedData.billOfExchangeat}</p>
              <p className="col-md-6">
                Pay to the order of: {selectedData.payToTheOrderOf}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Amount In Figures: {selectedData.amtInFigures}
              </p>
              <p className="col-md-6">
                Currency : {selectedData.currency}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                Amount Chargeable: {selectedData.amtChargable}
              </p>
              <p className="col-md-6">
                Drawn under: {selectedData.drawnUnder}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">Dated: {selectedData.dated}</p>

              <p className="col-md-6">
                Issued By : {selectedData.issuedBy}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">
                B/L Date(if Applicable):{" "}
                {selectedData.bLDate}
              </p>
              <p className="col-md-6">
                Remark/Note: {selectedData.remark}
              </p>
            </div>

          
            <h5>Reference Numbers Details</h5>
            <table className="table table-bordered table-sm text-center w-50">
              <thead>
                <tr>
                  <th>Shipper Reference No</th>
                  <th>Buyer Reference No</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    {selectedData.referenceNo[0] &&
                      selectedData.referenceNo[0].shipperReferenceNumber}
                  </td>
                  <td>
                    {selectedData.referenceNo[0] &&
                      selectedData.referenceNo[0].buyerReferenceNumber}
                  </td>
                </tr>
              </tbody>
            </table>

          

            <h5>Drawee/Drawer Details</h5>
            <table className="table table-bordered table-responsive table-sm text-center">
              <thead>
                <tr>
                  <th>Sr. No</th>

                  <th>Party Type</th>
                  <th>Name</th>
                  <th>Email Id</th>
                  <th>Contact Person Name</th>
                  <th>Contact Number</th>
                  <th>Address(landmark)</th>
                  <th>City</th>
                  <th>State</th>
                  <th>Zip Code</th>
                  <th>Country</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.drawerDetails &&
                  selectedData.drawerDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.partyType}</td>

                        <td>{itm.name}</td>
                        <td>{itm.email}</td>
                        <td>{itm.contactPersonName}</td>
                        <td>{itm.contactNumber}</td>
                        <td>{itm.landmark}</td>
                        <td>{itm.city}</td>
                        <td>{itm.state}</td>
                        <td>{itm.zipcode}</td>
                        <td>{itm.country}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default BillOfExchangeList;
